<template>
  <div class="template-add-edit-page1">
    <!-- page1 좌측 영역 -->
    <div class="template-page1-content left">
      <!-- 템플릿 -->
      <div class="template-group">
        <div class="group-title">{{$t("Header_Template")}}</div>
        <!-- 템플릿명 -->
        <div class="group-sub-title">{{$t("TP_Col_TemplateNm")}}</div>
        <div class="group-content">
          <!-- <input
            class="template-input"
            type="text"
            v-model="templateName"
            @change="(e) => saveInputValue({ templateName: templateName })"
          /> -->
          <InputComponent
            customClass="template-input"
            type="text"
            moduleName="template"
            name="templateName"
            :value="templateName"
            :validation="['required']"
          />
        </div>
        <!-- 업데이트 -->
        <div class="group-sub-title">{{$t("TP_Edit_1_Update")}}</div>
        <div class="group-content">
          <div class="buttons">
            <button
              class="basic-btn"
              :class="{ active: autoUpdate === 1 }"
              @click="() => onSelectValue('autoUpdate', 1)"
            >
              {{$t("TP_Edit_1_Update_Box1")}}
            </button>
            <button
              class="basic-btn"
              :class="{ active: autoUpdate === 0 }"
              @click="() => onSelectValue('autoUpdate', 0)"
            >
              {{$t("TP_Edit_1_Update_Box2")}}
            </button>
          </div>
        </div>
        <!-- 공개 여부 -->
        <div class="group-sub-title">{{$t("Common_Public_Or_Not")}}</div>
        <div class="group-content">
          <div class="buttons">
            <button
              class="basic-btn"
              :class="{ active: templatePublic === 1 }"
              @click="() => onSelectValue('templatePublic', 1)"
            >
              {{$t("Common_Public")}}
            </button>
            <button
              class="basic-btn"
              :class="{ active: templatePublic === 0 }"
              @click="() => onSelectValue('templatePublic', 0)"
            >
              {{$t("Common_Private")}}
            </button>
          </div>
        </div>
        <!-- 카테고리 -->
        <div class="group-sub-title">{{$t("TP_Edit_1_Category")}}</div>
        <div class="group-content">
          <a-select
            :value="category"
            @change="(value) => onSelectValue('category', value)"
          >
            <a-select-option
              v-for="(item, index) in categoryList"
              :key="index"
              :value="item.value"
              >{{ item.text }}</a-select-option
            >
          </a-select>
        </div>
        <!-- 언어 -->
        <div class="group-sub-title">{{$t("TP_Edit_1_Language")}}</div>
        <div class="group-content">
          <a-select
            :value="language"
            @change="(value) => onSelectValue('language', value)"
          >
            <a-select-option
              v-for="(item, index) in languageList"
              :key="index"
              :value="item.value"
              >{{ item.text }}</a-select-option
            >
          </a-select>
        </div>
        <!-- 템플릿 상태 -->
        <div v-if="mode === 'edit'" class="group-sub-title">{{$t("TP_Edit_1_TemplateStatus")}}</div>
        <div v-if="mode === 'edit'" class="group-content">
          <a-select
            :value="isEnable"
            @change="(value) => onSelectValue('isEnable', value)"
          >
            <a-select-option
              v-for="(item, index) in statusList"
              :key="index"
              :value="item.value"
              >{{ item.text }}</a-select-option
            >
          </a-select>
        </div>
      </div>
    </div>

    <!-- page1 우측 영역 -->
    <div class="template-page1-content right">
      <!-- 템플릿 유형 -->
      <div class="template-group">
        <div class="group-title">{{$t("TP_Edit_1_TemplateType")}}</div>
        <!-- 훈련 유형 -->
        <div class="group-sub-title">{{$t("TP_Edit_1_TrainingType")}}</div>
        <div class="group-content flex">
          <div
            class="exam-type-btn"
            :class="{ active: examType === 1 }"
            @click="() => onSelectValue('examType', 1)"
          >
            <div
              class="exam-type-item"
              v-for="(item, index) in examTypeData.slice(0, 3)"
              :key="index"
            >
              <img :src="item.icon" class="exam-type-icon" />
              <div class="exam-type-title">{{ item.title }}</div>
              <div class="exam-type-sub-title">{{ item.subTitle }}</div>
              <div class="exam-type-content" v-html="item.content"></div>
            </div>
          </div>
          <div
            class="exam-type-btn"
            :class="{ active: examType === 4 }"
            @click="() => onSelectValue('examType', 4)"
          >
            <div class="exam-type-item">
              <img :src="examTypeData[3].icon" class="exam-type-icon" />
              <div class="exam-type-title">{{ examTypeData[3].title }}</div>
              <div class="exam-type-sub-title">
                {{ examTypeData[3].subTitle }}
              </div>
              <div class="exam-type-content">{{ examTypeData[3].content }}</div>
            </div>
          </div>
        </div>
      </div>
      <!-- 발송 정보 -->
      <div class="template-group">
        <div class="group-title">{{$t("TP_Edit_1_SendInfo")}}</div>
        <!-- 메일 제목 -->
        <div class="group-sub-title">{{$t("TP_Edit_1_Mail_Title")}}</div>
        <div class="group-content">
          <!-- <input
            class="template-input"
            type="text"
            v-model="subject"
            @change="(e) => saveInputValue({ subject: subject })"
          /> -->
          <InputComponent
            customClass="template-input"
            type="text"
            moduleName="template"
            name="subject"
            :value="subject"
            :validation="['required']"
          />
        </div>
        <!-- 발송자 & 발송 이메일 -->
        <div class="flex">
          <div class="flex-item">
            <div class="group-sub-title">{{$t("TP_Edit_1_Sender")}}</div>
            <div class="group-content">
              <!-- <input
                class="template-input"
                type="text"
                v-model="sendName"
                @change="(e) => saveInputValue({ sendName: sendName })"
              /> -->
              <InputComponent
                customClass="template-input"
                type="text"
                moduleName="template"
                name="sendName"
                :value="sendName"
                :validation="['required']"
              />
            </div>
          </div>
          <div class="flex-item">
            <div class="group-sub-title">{{$t("TP_Edit_1_SendEmail")}}</div>
            <div class="group-content">
              <!-- <input
                class="template-input"
                type="text"
                v-model="sendEmail"
                @change="(e) => saveInputValue({ sendEmail: sendEmail })"
              /> -->
              <InputComponent
                customClass="template-input"
                type="text"
                moduleName="template"
                name="sendEmail"
                :value="sendEmail"
                :validation="['required', 'email']"
              />
              <span class="message">
                {{$t("TP_Edit_1_SendEmail_Guide_Text")}}
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { onMounted, reactive, ref, toRefs, watch, computed } from "vue";
import { useStore } from "vuex";
import InputComponent from "@/components/commonComponents/InputComponent";
import { useI18n } from "vue-i18n";

export default {
  name: "TemplateEditPage1",
  props: {
    mode: String,
    templateInfo: Object,
    saveInputValue: Function,
    currentPage: Number,
  },
  components: {
    InputComponent,
  },
  setup(props) {
    const editMode = props.mode === "edit" ? true : false;
    const store = useStore();
    const templateInputValues = computed(() => store.getters["template/GET_INPUT_VALUES"]);        
    const { t } = useI18n();

    const {
      templateName,
      autoUpdate,
      templatePublic,
      category,
      language,
      isEnable,
      examType,
      subject,
      sendName,
      sendEmail,
    } = templateInputValues.value;

    const formState = reactive({
      templateName: templateName ? templateName : "",
      autoUpdate: autoUpdate !== undefined ? autoUpdate : "",
      templatePublic: templatePublic !== undefined ? templatePublic : "",
      category: category !== undefined ? category : "",
      language: language !== undefined ? language : "",
      isEnable: isEnable !== undefined ? isEnable : 1,
      examType: examType !== undefined ? examType : "",
      subject: subject ? subject : "",
      sendName: sendName ? sendName : "",
      sendEmail: sendEmail ? sendEmail : "",
    });

    const categoryList = [
      { value: 0, text: t("TP_Edit_1_Category_Selec1") },
      { value: 1, text: t("TP_Edit_1_Category_Selec2") },
      { value: 2, text: t("TP_Edit_1_Category_Selec3") },
      { value: 3, text: t("TP_Edit_1_Category_Selec4") },
      { value: 4, text: t("TP_Edit_1_Category_Selec5") },
      { value: 5, text: t("TP_Edit_1_Category_Selec6") },
    ];

    const languageList = [
      { value: 0, text: t("TP_Edit_1_Language_selec1") },
      { value: 1, text: t("TP_Edit_1_Language_selec2") },
      { value: 2, text: t("TP_Edit_1_Language_selec3") },
      { value: 3, text: t("TP_Edit_1_Language_selec4") },
    ];

    const statusList = [
      { value: 1, text: t("TP_Edit_1_Status_List1") },
      { value: 0, text: t("Common_Delete") },
    ];

    const examTypeData = [
      {
        icon: "/img/template/exam_warning.png",
        title: t("Common_attach_title1"),
        subTitle: t("Common_attach_title2"),
        content: t("Common_attach_content1"),
      },
      {
        icon: "/img/template/exam_file.png",
        title: t("Common_attach_title3"),
        subTitle: t("Common_attach_title4"),
        content: t("Common_attach_content2"),
      },
      {
        icon: "/img/template/exam_cheat.png",
        title: t("Common_attach_title6"),
        subTitle: t("Common_attach_title7"),
        content: t("Common_attach_content3"),
      },
      {
        icon: "/img/template/exam_phishing.png",
        title: t("TP_Edit_1_ExamType_Title4"),
        subTitle: t("TP_Edit_1_ExamType_SubTitle4"),
        content: t("TP_Edit_1_ExamType_Content4"),
      },
    ];

    // 버튼, 드롭다운 선택 이벤트
    const onSelectValue = (name, value) => {
      formState[name] = value;

      // 선택 값 스토어에 저장
      props.saveInputValue({ [name]: value });
    };

    return {
      ...toRefs(formState),
      categoryList,
      languageList,
      statusList,
      examTypeData,
      onSelectValue,
    };
  },
};
</script>

<style>
</style>